import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";

import FieldError from "components/appCreator/items/form/FieldError";
import SimpleInput from "components/appCreator/items/form/SimpleInput";
import MarkdownEditor from "components/shared/markdownEditor/MarkdownEditor";

import styles from "./editFields.module.css";

function MarkdownEditorAdapter({ id, input, meta, disabled }) {
  return (
    <div className={`${styles.Text} property-${input.name}`}>
      <MarkdownEditor {...input} id={id} readOnly={disabled} />
      {meta.error && <FieldError error={meta.error} />}
    </div>
  );
}

MarkdownEditorAdapter.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    value: PropTypes.string,
    name: PropTypes.string,
  }),
  meta: PropTypes.shape(FieldError.propTypes),
  disabled: PropTypes.bool,
  id: PropTypes.string,
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
};

function TextField({
  name,
  required,
  multiline,
  disabled,
  id,
  autoFocus,
  inputRef,
  maxlength,
  ariaLabel,
}) {
  const props = multiline
    ? {
        component: MarkdownEditorAdapter,
        inputRef: inputRef,
      }
    : { component: SimpleInput, ref: inputRef };

  return (
    <Field
      id={id}
      type="text"
      className={`property-${name} form-input ${styles.Text}`}
      name={name}
      required={required}
      disabled={disabled}
      autoFocus={autoFocus}
      maxLength={maxlength}
      aria-label={ariaLabel}
      {...props}
    />
  );
}

TextField.propTypes = {
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  multiline: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  autoFocus: PropTypes.bool,
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  maxlength: PropTypes.number,
};

export default TextField;
